import { render, staticRenderFns } from "./question-interaction-component.vue?vue&type=template&id=327df122&scoped=true&"
import script from "./question-interaction-component.vue?vue&type=script&lang=ts&"
export * from "./question-interaction-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327df122",
  null
  
)

export default component.exports